import React, { useState, useEffect } from 'react'
import "./Chats.css"
import Chat from './Chat'
import axios from "./axios";

function Chats() {

    const [messages, setMessages] = useState([]);

    useEffect(()=>{
      async function fetchData(){
        const req= await axios.get('/tinder/chats');
        setMessages(req.data);
      }
      fetchData();
    }, []);


    return (
        <div className="chats">
            {messages.map((message)=> 
            <Chat name={message.name} message={message.message} timestamp={message.lastSeen} profilePic={message.imgUrl} />)}
        </div>
    )
}

export default Chats
